import React from "react"
import { motion } from "framer-motion"

const Section4: React.FC = () => {
  return (
    <div className="w-[50%] h-full bg-transparent relative overflow-hidden">
      <div className="w-full h-full flex flex-col pt-[5%]">
        <div className="w-[100px] self-center">
          <img src="./logos/logo.png" className="w-full h-full object-cover" />
        </div>
        <div className="flex-1 w-full px-8 py-8 gap-[15px] flex flex-col">
          <div>
            <p className="font-playfair font-bold text-[#092b16] text-[26px] text-justify flex-wrap">
              Hướng dẫn sử dụng:
            </p>
            <p className="text-[#092b16] text-[16px] text-justify flex-wrap">
              Thưởng thức: Tráng ấm trà bằng nước sôi, cho trà vào ấm, cho một
              lượng trà vừa đủ, cho nước sôi vào ấm và hãm trà từ 3-5 phút và
              thưởng thức.
            </p>
          </div>
          <div>
            <p className="font-playfair font-bold text-[#092b16] text-[26px] text-justify flex-wrap">
              Pha chế trà sữa, trà trái cây:
            </p>
            <p className="text-[#092b16] text-[16px] text-justify flex-wrap">
              50g Trà +1.300ml nước sôi 90 độ C, ủ 15-20 phút (đậy nắp khi ủ),
              lọc lấy nước thu được 1000ml cốt trà dùng pha chế (tùy phẩm trà)
              và từng sản phẩm sẽ có công thức riêng.
            </p>
          </div>
          <div>
            <p className="font-playfair font-bold text-[#092b16] text-[26px] text-justify flex-wrap">
              Hướng dẫn bảo quản:
            </p>
            <p className="text-[#092b16] text-[16px] text-justify flex-wrap">
              Để nơi khô ráo thoáng mát, đảm bảo vệ sinh, tránh ánh nắng trực
              tiếp.
            </p>
          </div>
          <div>
            <p className="font-playfair font-bold text-[#092b16] text-[26px] text-justify flex-wrap">
              Thông tin cảnh báo an toàn, vệ sinh:
            </p>
            <p className="text-[#092b16] text-[16px] text-justify flex-wrap">
              Không sử dụng khi sản phẩm bị mốc hoặc có mùi lạ.
            </p>
          </div>
          <div className="mt-[20px]">
            <p className="text-[#092b16] font-bold text-[16px] text-justify flex-wrap">
              Khối lượng tịnh: 500g
            </p>
            <p className="text-[#092b16] font-bold text-[16px] text-justify flex-wrap">
              NSX&HSD: Xem trên bao bì
            </p>
            <p className="text-[#092b16] font-bold text-[16px] text-justify flex-wrap">
              Sản xuất tại: Việt Nam
            </p>
          </div>
        </div>
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
          className="absolute bottom-0 left-0 right-0 z-20 backdrop-blur-sm text-white p-4"
          style={{ willChange: "transform, opacity" }}
        >
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-sm md:text-base text-[#092b16] font-medium">
              Sản phẩm của: Công ty TNHH TRÀ PHÚ SỸ
            </p>
            <p className="text-lg md:text-xl font-bold text-[#092b16]">
              SĐT: 0789399868 - GPKD: 5801302763
            </p>
            <p className="text-sm md:text-base font-bold text-[#092b16]">
              Địa chỉ: 166 Lý Thái Tổ, Thôn 6, Phường 2 Bảo Lộc, Tỉnh Lâm Đồng.
            </p>
            <p className="text-sm md:text-base font-bold text-[#092b16]">
              Điện thoại: 0913173838
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default Section4
